import styled from "styled-components";

export const PageContainer = styled.div`
  padding: 24px 72px;
  width: 100%;
  max-width: 1400px;
  min-width: 600px;
  box-sizing: border-box;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 16px 24px;
  }

  @media (max-width: 480px) {
    padding: 12px 16px;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const DebugButtonContainer = styled.div`
  /* Small button styling for testing purposes */
`;

export const TabsContainer = styled.div<{ disabled?: boolean }>`
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  pointer-events: ${props => (props.disabled ? "none" : "auto")};
  transition: opacity 0.2s;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;

  @media (max-width: 480px) {
    flex-wrap: wrap;
  }
`;

export const TableActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const TableContainer = styled.div`
  margin-top: 0;

  @media (max-width: 768px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

export const TableHeader = styled.div<{ disabled?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 150px 72px;
  gap: 8px;
  padding: 0 8px 8px 8px;
  font-size: 11px;
  font-weight: 700;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  border-bottom: 1.5px solid #ddd;
  margin-bottom: 4px;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  transition: opacity 0.2s;

  @media (max-width: 768px) {
    min-width: 450px;
  }
`;

export const HeaderCell = styled.div<{
  $center?: boolean;
  $shiftLeft?: boolean;
}>`
  display: flex;
  justify-content: ${props =>
    props.$center ? "center" : props.$shiftLeft ? "flex-end" : "flex-start"};
  align-items: center;
`;

export const TableBody = styled.div<{ disabled?: boolean }>`
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  transition: opacity 0.2s;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 32px;
`;

export const LabelText = styled.span<{ disabled?: boolean }>`
  font-size: 11px;
  font-weight: 700;
  color: #555;
  text-transform: uppercase;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  transition: opacity 0.2s;
`;

export const SwitchWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  pointer-events: auto;
  cursor: pointer;

  /**
   * MUI Override: Hide checkmark icon inside Switch thumb
   * Reason: Interstate Switch renders a checkmark SVG icon inside the thumb by default.
   * No prop exists to disable this icon. Design requires a plain thumb without icon.
   */
  .MuiSwitch-thumb svg {
    display: none;
  }

  /**
   * MUI Override: Style Interstate Switch label for enable/include-all toggles
   * Reason: Interstate Switch does not expose props to customize label styling.
   * Design requires uppercase, bold, small font (11px) with opacity transition.
   */
  .MuiFormControlLabel-label,
  label.MuiFormControlLabel-label,
  span.MuiFormControlLabel-label {
    font-size: 11px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    color: #555 !important;
    opacity: ${props => (props.disabled ? 0.5 : 1)} !important;
    transition: opacity 0.2s;
  }

  /* Ensure all Switch elements are clickable */
  .MuiSwitch-root,
  .MuiSwitch-switchBase,
  .MuiSwitch-input {
    cursor: pointer;
    pointer-events: auto;
  }
`;

export const CursorTooltip = styled.div.attrs<{
  $visible: boolean;
  $x: number;
  $y: number;
}>(props => ({
  style: {
    left: `${props.$x}px`,
    top: `${props.$y}px`
  }
}))<{
  $visible: boolean;
  $x: number;
  $y: number;
}>`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.87);
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  pointer-events: none;
  z-index: 9999;
  white-space: nowrap;
  opacity: ${props => (props.$visible ? 1 : 0)};
  transition: opacity 0.2s;
  transform: translate(12px, 12px);
`;

export const LoadingOverlay = styled.div<{ $visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: ${props => (props.$visible ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 10000;
  pointer-events: none;
`;

export const LoadingSpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #333333;

  &::before {
    content: "";
    width: 40px;
    height: 40px;
    border: 4px solid #e0e0e0;
    border-top: 4px solid #0066cc;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
